import styled from "styled-components";

export const IMG_SIZE = 100;

export const AvatarWrapper = styled.div`
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  min-width: ${(props) => props.size};
  min-height: ${(props) => props.size};

  border-radius: 50%;
  background: #ececec;
  overflow: hidden;
  > img {
    width: 100%;
    font-size: 0;
  }
`;

AvatarWrapper.defaultProps = {
  size: `${IMG_SIZE}px`,
};

export const NameIntialAvatar = styled.div`
  height: 100%;
  line-height: initial;
  text-align: center;
  color: #b3b3b3;
  background: #ececec;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: calc(${(props) => props.size} / 2.5);
  text-decoration: none !important;
  &:hover {
    background: #d4d4d4;
  }
`;

NameIntialAvatar.defaultProps = {
  size: `${IMG_SIZE}px`,
};
